<template>
  <div class="faultReport">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.phone" placeholder="用户手机号" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-select v-model="request.type" clearable="true" placeholder="类型">
              <el-option v-for="(item, index) in global.feed_back" :key="index" :label="item.message" :value="item.code"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="time" :append-to-body="false" type="daterange" range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" @change="chooseTime"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getFeedback()">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableData">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"
                style="margin:auto;width:calc(100% - 30px)" height="730" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="ID" align="center" prop="id" width="150"></el-table-column>
        <el-table-column label="类型" align="center" prop="typeStr"></el-table-column>
        <el-table-column label="标题" align="center" prop="title"></el-table-column>
        <el-table-column label="内容" width="543" align="center" prop="content"></el-table-column>
        <el-table-column label="用户手机号" align="center" prop="phone"></el-table-column>
        <el-table-column label="创建时间" align="center" width="200">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" width="200">通过手机号去查询具体订单</el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="warning" size="small" plain @click="detail(scope.row.url)" >详情</el-button>
           <el-button type="warning" size="small" plain @click="handle(scope.row.id)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    <el-dialog :visible.sync="feedbackDialog" width="52%" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false top="8vh" @close="closeDialog">
      <el-card>
        <div style="height: 600px;">
          <img v-if="url != null" :src="url" width="100%" height="100%"/>
          <div v-if="url == null" width="100%" height="100%">反馈的用户未上传图片</div>
        </div>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import {getFaultReportInfo,handleFeedback } from "../../api/oder/faultreport.js";
import {GLOBAL_URL} from '../../config/config.js'
import {formatDate} from "../../utils/date";
export default {
  name: "FaultReport",
  data() {
    return {
      request: {
        phone: '',
        type: '',
        startTime: '',
        endTime: '',
        current: '',
        size: ''
      },
      global: '',
      time: '',
      loadText: '',
      response: {data:[], total: 0},
      query: {current: 1, size: 15},
      loading: false,
      feedbackDialog: false,
      url: ''
    };
  },
  methods:{
    /**
     * 时间选择触发事件
     */
    chooseTime(events){
      this.request.startTime = events[0];
      this.request.endTime = events[1];
    },

    /**
     * 页码改变触发事件
     */
    currenChangeHandle(value) {
      this.query.current = value;
      this.getFeedback()
    },

    /**
     * 查询故障上报列表
     */
    getFeedback(){
      this.loadText = "数据加载中";
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getFaultReportInfo(this.request).then(result=>{
          this.response.data = result.data.records
          this.response.total = result.data.total
        })
    },

    /**
     * 重置
     */
    reset(){
      this.request.phone = "";
      this.request.type = "";
      this.request.startTime = "";
      this.request.endTime = "";
      this.request.current = 1;
      this.request.size = 10;
      this.getFeedback();

    },

    /**
     * 处理
     */
    handle(id){
      this.loadText = "请求处理中";
      handleFeedback({id: id});
      this.$message({
        message: "操作成功",
        type: "success",
        duration: 1500,
        });
      this.getFeedback();
    },

    /**
     * 详情
     */
    detail(value){
      if(value == null || value == undefined){
        this.url = null;
      }else{
        this.url = GLOBAL_URL.imageUrl+value
      }
      this.feedbackDialog = true

    },

    /**
     * 关闭dialog
     */
    closeDialog(){
      this.url = '';
    }
  },
  filters: {
  formatDate(time) {
    var date = new Date(time);
    return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
  }
},
  created() {
    this.global = JSON.parse(sessionStorage.getItem("global"))
    this.getFeedback();
},
}
</script>

<style scoped>
.faultReport {
  width: 100%;
  height: 100%;
}

.el-form {
  float: left;
}

.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ordermanagement/faultreport.vue